export const whitePageTypes = {
  loading: 'whitepage/loading',
  success: 'whitepage/success',
  reject: 'whitepage/reject',
};
